import React from "react";
import ErrorField from "./error";
import Big from "big.js";
import { CurrencyField } from "components/support";
import { observer } from "mobx-react";

const StockCountField = ({ errors, row, onChange }) => {
  const { stock_count } = row;
  let parsedStockCount = "0.00";
  if (stock_count && stock_count.length !== 0) {
    parsedStockCount = Big(stock_count).toFixed(2);
  }
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.stock_count;

  return (
    <div>
      <CurrencyField
        value={parsedStockCount}
        onChange={(_, value) =>
          onChange(Big(value.replace(/\D/g, "")).div(100))
        }
        fullWidth
        unit=""
      />
      {hasErrors && <ErrorField error={foundErrors.errors.stock_count} />}
    </div>
  );
};

export default observer(StockCountField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/stock-count.js